export default __webpack_public_path__ + "static/media/Vaquform DT2.07b297e7.png";